import { useError } from "./useNotifications";
import { api } from "../actions/api";
import { useIsEmbedded } from "./useIsEmbedded";

export const useCreateCheckoutSession = (url, converter) => {
    const isEmbedded = useIsEmbedded();
    const { notifyResponseError } = useError();
    return values => {
        return api.post(url, converter ? converter(values) : values)
            .then(
                ({ data }) => isEmbedded ? window.open(data.session_url, "_parent") : window.location.href = data.session_url,
                e => notifyResponseError(e)
            );
    };
};
